module.exports = __webpack_public_path__ + "img/qr_grey.b86a8404.svg";